module.exports = __webpack_public_path__ + "img/no.56f62ee1.svg";